
export class JsonUtil {
  /**
   * JSON文字列からJSONオブジェクトに変換します.
   * 変換に失敗した場合、nullを返却します.
   *
   * @param value JSON文字列
   * @returns JSONオブジェクト
   */
  public static toObject(value: string): any {
    if (!value) {
      return null;
    }

    let v = null;

    try {
      v = JSON.parse(value);
    } catch (err) {
      console.error(err);
    }

    return v;
  }

  /**
   * JSONオブジェクトからJSON文字列に変換します.
   * 変換に失敗した場合、nullを返却します.
   *
   * @param value JSONオブジェクト
   * @param replacer 文字列化の手順の挙動を変更する関数、または値のオブジェクトを
   *  JSON 文字列に含めるプロパティを選択する許可リストとして機能する String と Number の配列。
   *  もしこの値が null であるか提供されなかった場合は、結果の文字列にオブジェクトのすべてのプロパティが含まれます。
   * @param space 出力する JSON 文字列に可読性を目的に空白を挿入するために使う String または Number オブジェクトです。
   * @returns JSON文字列
   */
  public static toString(value: any, replacer?: (this: any, key: string, value: any) => any, space?: string | number): string {
    if (!value) {
      return '';
    }

    let v = null;

    try {
      v = JSON.stringify(value, replacer, space);
    } catch (err) {
      console.error(err);
    }

    return v;
  }
}



// WEBPACK FOOTER //
// ./src/utilities/json-util.ts